import { useState, useEffect } from "react";
import { useStore, useSelector, useDispatch } from "react-redux";
import { hasAnyRole } from "~/utils/user";

import { fetchWordingTemplates } from "~/redux/actions/wording";

export const useWordingTemplates = ({ scenario }) => {
  const wordingTemplates = useSelector(
    (state) => state.wording.wordingTemplates.wording_templates || []
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [keyword, setKeyword] = useState(null);
  const [currentTemplate, setCurrentTemplate] = useState(null);

  const store = useStore();
  const { user } = store.getState().user;
  const isAdmin = hasAnyRole(user, ["admin"]);
  const token = store.getState().user.token;
  const dispatch = useDispatch();

  const fetchData = () => {
    if (!isAdmin) {
      return;
    }
    setLoading(true);
    dispatch(fetchWordingTemplates(token, 1, scenario, keyword))
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [scenario, keyword]);

  return {
    isAdmin,
    wordingTemplates,
    loading,
    error,
    keyword,
    setKeyword,
    currentTemplate,
    setCurrentTemplate,
    refetchWordingTemplates: fetchData,
  };
};
